import './content.sass';

export { default } from './content';
